// extracted by mini-css-extract-plugin
export default {"icon":"CategoryIcon_icon__M48PX"};